const PresentismoAyudaIcon = ({width, height}) => {
  return (
    <svg
      width={width ? width : "13"}
      height={height ? height : "14"}
      viewBox="0 0 13 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.72039 8.16388V8.06729C5.72228 7.73585 5.75164 7.47165 5.80846 7.27468C5.86717 7.07771 5.9524 6.91862 6.06414 6.79741C6.17588 6.6762 6.31035 6.56635 6.46755 6.46786C6.58497 6.3921 6.69009 6.31351 6.78289 6.23207C6.87569 6.15063 6.94956 6.06067 7.00448 5.96218C7.0594 5.8618 7.08687 5.75006 7.08687 5.62695C7.08687 5.49627 7.05562 5.38169 6.99312 5.2832C6.93062 5.18472 6.84634 5.10896 6.74028 5.05593C6.63611 5.0029 6.52058 4.97638 6.39369 4.97638C6.27058 4.97638 6.1541 5.00385 6.04425 5.05877C5.9344 5.1118 5.84444 5.19135 5.77437 5.29741C5.70429 5.40157 5.66641 5.53131 5.66073 5.68661H4.50164C4.51111 5.30782 4.60202 4.99532 4.77437 4.74911C4.94672 4.50101 5.17494 4.31635 5.45903 4.19513C5.74312 4.07203 6.05656 4.01048 6.39937 4.01048C6.77626 4.01048 7.10959 4.07298 7.39937 4.19798C7.68914 4.32108 7.91641 4.50006 8.08119 4.73491C8.24596 4.96976 8.32834 5.2529 8.32834 5.58434C8.32834 5.80593 8.29141 6.0029 8.21755 6.17525C8.14558 6.3457 8.04425 6.49722 7.91357 6.62979C7.78289 6.76048 7.62853 6.87885 7.4505 6.98491C7.30088 7.07392 7.17778 7.16673 7.08119 7.26332C6.98649 7.35991 6.91547 7.47165 6.86812 7.59854C6.82266 7.72544 6.79899 7.88169 6.79709 8.06729V8.16388H5.72039ZM6.28289 9.98207C6.0935 9.98207 5.93156 9.91578 5.79709 9.7832C5.66452 9.64873 5.59918 9.48775 5.60107 9.30025C5.59918 9.11464 5.66452 8.95555 5.79709 8.82298C5.93156 8.6904 6.0935 8.62411 6.28289 8.62411C6.46281 8.62411 6.62096 8.6904 6.75732 8.82298C6.89369 8.95555 6.96281 9.11464 6.96471 9.30025C6.96281 9.42525 6.92967 9.53983 6.86528 9.644C6.80278 9.74627 6.72039 9.82866 6.61812 9.89116C6.51584 9.95176 6.4041 9.98207 6.28289 9.98207Z"
        fill="white"
      />
      <circle
        cx="6.44762"
        cy="6.84703"
        r="5.43199"
        stroke="white"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default PresentismoAyudaIcon;
